import { useState } from 'react';
import './menuStyles.css';
import { useAuth } from '../../auth/AuthContext';
import { menuAdmin } from './menuAdmin';
import { menuMedico } from './menuMedico';
import { useNavigate } from 'react-router-dom'
 
 
const Menu = () => {
  const navigate = useNavigate()
  const [activeMenu, setActiveMenu] = useState<number | null>(null);
	const auth = useAuth()
	const menuItems = auth.role === 'A' ? menuAdmin : menuMedico
 
	const handleAction = (action?: () => void) => {
	  return () => {
		setActiveMenu(null); // Cerrar todos los menús
		action?.(); // Ejecutar la acción si existe
	  };
  };
 
  return (
	<nav className="menu-container">
	  <ul className="main-menu">
		{menuItems(navigate).map((item, index) => (
		  <li 
			key={index}
			className="menu-item"
			onMouseEnter={() => setActiveMenu(index)}
			onMouseLeave={() => setActiveMenu(null)}
		  >
			<button 
			  className="menu-button"
			  onClick={handleAction(item.action)}
			>
			  {item.icon && <span className="menu-icon">{item.icon}</span>}
			  {item.label}
			  {item.subItems && ' ▼'}
			  {/* {item.subItems && <span className="dropdown-arrow">▼</span>} */}
			</button>
 
			{item.subItems && activeMenu === index && (
			  <ul className="submenu">
				{item.subItems.map((subItem, subIndex) => (
				  <li key={subIndex} className="submenu-item">
					<button 
					  className="submenu-button"
					  onClick={handleAction(subItem.action)}
					>
					  {subItem.icon && <span className="menu-icon">{subItem.icon}</span>}
					  {subItem.label}
					</button>
				  </li>
				))}
			  </ul>
			)}
		  </li>
		))}
	  </ul>
	</nav>
  );
};
 
export default Menu;